:host {
  display: block;
  min-width: 1px;
  height: 100%;
  cursor: ew-resize;
}

.resize-mask {
  position: fixed;
  inset: 0;
}